/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import * as R from 'ramda';

const initialState = {
  currentPtoDialogueOpen: '',
  ptoNumber: null,
};

/**
 * Equivalent to the traditional reducer but:
 * - no switch statement
 * - no action constants
 * - able to apply updates in a mutable way
 */

const reducers = {
  resetCurrentPtoDialog() {
    return initialState;
  },
  setCurrentPtoDialogueOpen(state, { payload }) {
    // ptoDialogueType can be one of 'accept', 'reject', 'cancel'
    return R.evolve(
      {
        currentPtoDialogueOpen: R.always(R.prop('ptoDialogueType', payload)),
        ptoNumber: R.always(R.or(R.prop('ptoNumber', payload), R.prop('ptoNumber', state))),
      },
      state
    );
  },
  setPtoNumber(state, { payload }) {
    return R.assoc('ptoNumber', payload, state);
  },
};

/**
 * createSlice takes the initialState and reducers and returns an object containing:
 * - auto generated action creators
 * - a derived reducer function that doesn't mutate state
 */
const { actions, reducer } = createSlice({
  initialState,
  name: 'ptoDrawer',
  reducers,
});

export const { resetCurrentPtoDialog, setPtoNumber, setCurrentPtoDialogueOpen } = actions;

export default reducer;
